export const getReplaceVideoStyle = () => ({
  root: {
    '& .placeholder-contents': {
      width: '750px',
      border: '1px solid #C8C8C8',
      margin: '8px 0 0 0',
      padding: '16px 16px 12px 16px',


      '& .placeholder-alert-header': {

        display: 'flex',
        '& .placeholder-alert-title': {
          fontWeight: 600,
          fontSize: '16px',
          paddingRight: '10px',
        },
      },

      '& .placeholder-body': {
        display: 'flex',
        marginTop: 4,

        '& .button': {
          height: 24,
          minWidth: 56,
          width: 56,
        },

        '& .place-holder-img-container': {
          width: '200px',
          '& .placeholder-video-replace-img': {
            height: 'auto',
            width: '100%',
            marginRight: '25px',
          },
        },


        '& .placeholder-action': {
          '& .placeholder-video-info': {
            margin: '10px 0',
            '& .placeholder-list-name': {
              fontWeight: 600,
              paddingRight: '10px',
            },

            '& .upload-progress': {
              display: 'flex',
            },

            '& li': {
              display: 'flex',
              '& .placeholder-copy-link': {
                border: '0',
                textDecoration: 'underline',
                backgroundColor: 'transparent',
                display: 'flex',

                '& .url-copied': {
                  display: 'none',
                  color: '#2ba573',
                  textDecoration: 'none',
                },

                '& div': {
                  padding: '0 5px',
                },

                '& .placeholder-list-name': {
                  padding: '0 5px',
                },

              },

              '& .placeholder-copy-link:hover': {
                textDecoration: 'none',
              },

              '& .placeholder-copy-link:focus': {
                textDecoration: 'none',

                '& .url-copied': {
                  display: 'block',

                },
              },
            },

          },

          '& .google-import-video-ad-message': {
            paddingTop: 15,
          },
        },

      },
    },
  },
});
